import styled from 'styled-components';
import { BreakPoint } from '@makemydeal/dr-activities-common';

export const PriceContainer = styled.div`
    display: flex;
    align-items: center;
    padding-right: 0.5rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
    font-size: ${({ theme }) => theme.tokens.BrandTypographyFontSizeBase};
    border-top: 1px solid ${({ theme }) => theme.tokens.BaseColorGray300};
    border-bottom: 1px solid ${({ theme }) => theme.tokens.BaseColorGray300};
`;

export const PriceValue = styled.div`
    flex: 1;
    text-align: right;
    font-weight: 500;
`;

export const TextInputContainer = styled.div`
    input {
        text-align: right;
    }
`;

export const ResponsiveFieldRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    @media (min-width: ${BreakPoint.SCREEN_SM_MIN}) {
        flex-direction: row;
        align-items: flex-start;

        > * {
            flex: 1;
        }
    }
`;

export const ProfitContainer = styled.div`
    display: flex;
    font-size: ${({ theme }) => theme.tokens.BrandTypographyFontSizeBase};
    font-weight: 400;
    line-height: ${({ theme }) => theme.tokens.BaseSizeFont20};
    letter-spacing: 0em;
    text-align: left;
    margin-top: 1.5rem;
`;

export const UpfrontContainer = styled.div`
    display: flex;
    font-size: ${({ theme }) => theme.tokens.BrandTypographyFontSizeBase};
    font-weight: 400;
    line-height: ${({ theme }) => theme.tokens.BaseSizeFont20};
    letter-spacing: 0em;
    text-align: left;
    margin-top: 1.5rem;
`;

export const RadioButtonListContainer = styled.div`
    margin-top: ${({ theme }) => theme.tokens.BaseSpace40};

    .ids-input-layout-message-spacer {
        display: none;
    }

    .ids-input-layout-horizontal div:first-of-type {
        width: 100%;
    }
`;
